module.exports = __webpack_public_path__ + "static/media/trainer-woman.min.e387b652.webp";